<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import { useRoute } from 'vue-router'
import { useProjectStore } from '@/stores/project'
import { useScenarioStore } from '@/stores/scenario'
import { useProjectUserStore } from '@/stores/projectUser'
import { useAuthorizationStore } from '@/stores/authorization'
import { useDjangoAuthStore } from '@/stores/authDjango'
import { storeToRefs } from 'pinia'
import _ from 'lodash'
import ProjectSideBar from '@/components/project-detail/ProjectSideBar.vue'
import { AppBackground, ProjectHeaderImage } from '@haskoning/vue-component-library'
import type { ProjectUserType } from '@/stores/type/projectUser.type'

const route = useRoute()

const projectStore = useProjectStore()
const scenarioStore = useScenarioStore()

const authStore = useDjangoAuthStore()
const projectUserStore = useProjectUserStore()
const authorizationStore = useAuthorizationStore()

const { currentItem: currentProjectItem } = storeToRefs(projectStore)
const { fetchLoading: calculationFetchLoading } = storeToRefs(scenarioStore)
const { items: projectUsers } = storeToRefs(projectUserStore)
const { user: currentUser } = storeToRefs(authStore)

onMounted(async () => {
  calculationFetchLoading.value = true
  if (!currentProjectItem.value || _.isEmpty(currentProjectItem.value)) {
    await projectStore.fetchOptions()
    const projectId = route.params.id as string
    await projectStore.fetchItem(parseInt(projectId))
  }

  if (currentProjectItem.value) {
    const { id } = currentProjectItem.value

    if (id) {
      await projectUserStore.fetchItems({ search: id })
      await authorizationStore.fetchItems()

      const currentProjectUser = projectUsers.value.find(
        (item: ProjectUserType) => item.user === currentUser?.value?.id
      )
      authorizationStore.setCurrentRole([currentProjectUser?.role])

      await scenarioStore.fetchOptions()
      await scenarioStore.fetchItems({ search: id })
      scenarioStore.setSelectedItems([])
    }
  }

  calculationFetchLoading.value = false
})

onUnmounted(() => {
  projectStore.resetAll()
  scenarioStore.resetAll()
})
</script>
<template>
  <div style="display: flex; flex-direction: column" class="fill-height">
    <ProjectHeaderImage :lazy-src="'/header_lazy.jpg'" :src="'/header.jpeg'" />
    <AppBackground>
      <ProjectSideBar />
      <router-view></router-view>
    </AppBackground>
  </div>
</template>

<style scoped></style>
